import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'Réalisations', path: '/realisations' },
    { name: 'Offres Entreprises', path: '/offres-entreprises' },
    { name: 'À propos', path: '/a-propos' },
    { name: 'Contact', path: '/contact' }
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled
            ? 'bg-black/95 backdrop-blur-md shadow-lg'
            : 'bg-black/30 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/abfd1896-5d84-4bae-9ef9-cd88b8f43695.png" 
                alt="Grande Imprimerie Logo" 
                className="h-12 w-auto object-contain"
              />
              <span className="text-white text-xl font-bold tracking-wide">
                GRANDE IMPRIMERIE
              </span>
            </Link>

            {/* Navigation Links */}
            <div className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-white text-sm font-medium tracking-wide transition-all duration-300 relative group whitespace-nowrap cursor-pointer ${
                    location.pathname === link.path ? 'text-[#E63946]' : ''
                  }`}
                >
                  {link.name}
                  <span
                    className={`absolute bottom-0 left-0 w-0 h-0.5 bg-[#E63946] transition-all duration-300 group-hover:w-full ${
                      location.pathname === link.path ? 'w-full' : ''
                    }`}
                  ></span>
                </Link>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="hidden lg:flex items-center space-x-4">
              <Link
                to="/commande-devis"
                className="bg-[#E63946] text-white px-6 py-3 rounded-full font-bold text-sm shadow-lg hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Demander un Devis
              </Link>
              <a
                href="https://wa.me/2250779027536"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all duration-300 relative cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-xl"></i>
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#E63946] rounded-full animate-ping"></span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white text-2xl cursor-pointer"
              onClick={() => {
                const menu = document.getElementById('mobile-menu');
                if (menu) {
                  menu.classList.toggle('hidden');
                }
              }}
            >
              <i className="ri-menu-line"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div id="mobile-menu" className="hidden lg:hidden bg-black/95 backdrop-blur-md">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block text-white text-sm font-medium py-2 cursor-pointer ${
                  location.pathname === link.path ? 'text-[#E63946]' : ''
                }`}
                onClick={() => {
                  const menu = document.getElementById('mobile-menu');
                  if (menu) {
                    menu.classList.add('hidden');
                  }
                }}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/commande-devis"
              className="block bg-[#E63946] text-white px-6 py-3 rounded-full font-bold text-sm text-center whitespace-nowrap cursor-pointer"
              onClick={() => {
                const menu = document.getElementById('mobile-menu');
                if (menu) {
                  menu.classList.add('hidden');
                }
              }}
            >
              Demander un Devis
            </Link>
          </div>
        </div>
      </nav>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/2250779027536"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-all duration-300 z-50 animate-pulse cursor-pointer"
        style={{ boxShadow: '0 0 30px rgba(37, 211, 102, 0.5)' }}
      >
        <i className="ri-whatsapp-fill text-white text-3xl"></i>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#E63946] rounded-full animate-ping"></span>
      </a>
    </>
  );
};

export default Navbar;